import React from 'react'
import { IMaskInput } from 'react-imask'

const PhoneInput = ({ disabled = false, label, name, value, onChange, required = false }) => {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={name} className="text-lg text-blueDarker font-normal">
          {label}{required && <span className="ml-1.5">*</span>}
        </label>
      )}
      <IMaskInput
        id={name}
        name={name}
        required={required}
        disabled={disabled}
        value={value}
        mask="(00) 0 0000-0000"
        onAccept={(val) => onChange({ target: { name, value: val } })}
        className="w-full border border-bluePale rounded-xl px-3 py-3 text-base placeholder-blueSteel"
        placeholder=""
      />
    </div>
  )
}

export default PhoneInput
